import React from "react";
import LoadSpinner from "../../../common/spinner/loadSpinner";
import Menucustom from "../../../common/menu/menucustom";
import { MapContainer, TileLayer, useMap, Popup, Marker, MapConsumer } from "react-leaflet";
import DashboardMappatureService from "./dashboardMappatureService";
import { geDataFormat } from "../../../common/utils";
import { Route, withRouter } from "react-router-dom";
import HandlerMarker from "./handlerMarker";
import moment from "moment";
class DashboardMappature extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: [],
      loading: true,
      loadingMap:true,
      datiMarker: [
        {
          id: 0,
          lat: 0,
          lng: 0,
          data: 0,
          idCliente: 0,
          idSanzione: 0,
        },
      ],
      detailMarker: {},
      filtro: {
        dataInizio: "",
        dataFine: "",
        matricola: "",
      },
    };

    this.geDataFormat = geDataFormat.bind(this);
  }
  componentDidMount() {
    this.dashboardMappatureService = new DashboardMappatureService();
    // this.setState({ loading: true });
    var filtriMappatura = JSON.parse(sessionStorage.getItem("filtriMappatura"));

    if (filtriMappatura) {
      this.state.filtro = filtriMappatura;
      sessionStorage.removeItem("filtriMappatura");
    } else {
      // sessionStorage.removeItem("filtriMappatura");
    }
    this.resetFiltersDates(true)
    this.applicaFiltri()

    this.dashboardMappatureService.getMatricole((result) => {
      this.setState({ user: result });
      this.setState({ loading: false });
    });
  }

  resetFiltersDates(isMount) {
    if(isMount == null && isMount == undefined) isMount = false;
    this.state.filtro.dataFine = moment(new Date()).format("YYYY-MM-DD");
    this.state.filtro.dataInizio = moment(this.state.filtro.dataFine, "YYYY-MM-DD").subtract(29, "d").format("YYYY-MM-DD");
    if(!isMount) {
      this.setState({filtro: this.state.filtro})
    }
  }

  onChangeDataInizio(event) {
    this.state.filtro.dataInizio = event.target.value;
    this.setState({ filtro: this.state.filtro });
  }

  onChangeDataFine(event) {
    this.state.filtro.dataFine = event.target.value;
    this.setState({ filtro: this.state.filtro });
  }

  onChangeMatricola(event) {
    this.state.filtro.matricola = event.target.value;
    this.setState({ filtro: this.state.filtro });
  }

  applicaFiltri() {
    this.setState({loadingMap:true})
    if (this.state.filtro.matricola === "") {
      this.dashboardMappatureService.getAllMarker(
          this.state.filtro.dataInizio,
          this.state.filtro.dataFine,
          (result) => {
            // this.state.datiMarker =result.data;
            this.setState({ datiMarker: result.data });
            this.setState({loadingMap:false})
          }
      );
    } else {
      this.dashboardMappatureService.getAllMarkerByMatricola(
          this.state.filtro.matricola,
          this.state.filtro.dataInizio,
          this.state.filtro.dataFine,
          (result) => {
            // this.state.datiMarker =result.data;
            this.setState({ datiMarker: result.data });
            this.setState({loadingMap:false})
          }
      );
    }
  }

  render() {
    // console.log(this.state.datiMarker);

    let content = this.state.loading ? (
      <LoadSpinner />
    ) : (
      <>
        <div id="wrapper">
          <Menucustom />
          {/* <div className="container-fluid">
            <small style={{ fontSize: "14px" }} className="mb-2 text-gray-800">
              Dashboard &#8594; Mappature
            </small>
            <br />
            <iframe
              src="http://35.205.186.202:3000/d/DZADcGU7k/mappatura-sanzioni?orgId=1&from=now-30d&to=now&kiosk"
              frameborder="10"
              height="95%"
              width="97%"
            />
          </div>
          <br></br> */}
          <div className="container-fluid">
            <small style={{ fontSize: "14px" }} className="mb-2 text-gray-800">
              Dashboard &#8594; Mappature
            </small>

            <br />
            <br></br>
            <div className="row form-group">
              <div className="col">
                <label>Data Inizio : </label>{" "}
                <input
                  value={this.state.filtro.dataInizio}
                  type="date"
                  className="form-control"
                  onChange={this.onChangeDataInizio.bind(this)}
                />
              </div>
              <div className="col">
                <label>Data Fine : </label>{" "}
                <input
                  value={this.state.filtro.dataFine}
                  type="date"
                  className="form-control"
                  onChange={this.onChangeDataFine.bind(this)}
                />
              </div>

              <div className="col">
                <label>Matricola : </label>{" "}
                <select
                  className="form-control"
                  onChange={this.onChangeMatricola.bind(this)}
                >
                  {/* {this.state.filtro.matricola? 
                      <option selected value={this.state.filtro.matricola}>
                      {this.state.filtro.matricola}
                    </option>
                    :this.state.filtro.matricola === 0 ? "" : ""} */}

                  <option value={""}>Matricola</option>
                  {this.state.user.map((val, index) => {
                    // if(index === 0){
                    //   if(this.state.filtro.matricola.length > 0){
                    //     <option selected value={this.state.filtro.matricola}>
                    //     {this.state.filtro.matricola}
                    //   </option>
                    //   }
                    // }
                    if (val.ruolo === "Verificatore") {
                      return (
                        <>
                          {this.state.filtro.matricola === val.numMatricola ? (
                            <option selected value={val.numMatricola}>
                              {val.numMatricola}
                            </option>
                          ) : (
                            <option value={val.numMatricola}>
                              {val.numMatricola}
                            </option>
                          )}
                        </>
                      );
                    }
                  })}
                </select>
                {/* <input value={""} type="date" 
                className="form-control"
                onChange={this.onChangeMatricola.bind(this)}
                /> */}
              </div>
                <div className="col justify-content-end align-items-end d-flex">
                  <button className="btn btn-primary d-flex justify-content-center align-items-center gap-2"
                  onClick={() => this.applicaFiltri()}>
                    <i className="fas fa-search"></i>
                    Applica
                  </button>
                </div>

                <div className="col align-items-end d-flex">
                  <button
                      className="btn btn-warning d-flex justify-content-center align-items-center gap-2"
                      onClick={() => {
                        sessionStorage.removeItem("filtriMappatura");
                        this.state.filtro.matricola = ""
                        this.resetFiltersDates()
                        this.applicaFiltri()
                      }}
                  >
                    <i className="fas fa-sync-alt"></i>
                    Reset
                  </button>
                </div>
            </div>

            <br></br>
            {this.state.loadingMap
            ? <LoadSpinner/>
            :(<MapContainer
              className="leaflet-container"
              center={[45.85763742217644, 9.402929298375199]}
              zoom={13}
              minZoom={13}
              maxZoom={18}
              style={{ height: '70%', width: '100%' }}
            >
              <MapConsumer>
                {
                  (map) => {
                    return(
                      <HandlerMarker  push={this.props.history.push} datiMarker={this.state.datiMarker} leaflet={map}/>
                  )
                }}
              </MapConsumer>
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              />
            </MapContainer>)}
          </div>
        </div>
      </>
    );
    return <div>{content}</div>;
  }
}

//  const iconPerson = new L.Icon({
//   iconUrl: iconsvg,
//   iconRetinaUrl: iconsvg,
//   iconAnchor: null,
//   popupAnchor: null,
//   shadowUrl: iconsvg,
//   shadowSize: null,
//   shadowAnchor: null,
//   iconSize: new L.Point(60, 75),
//   className: 'red',
// });

// export { iconPerson };
export default withRouter(DashboardMappature);
